function parseGraphQlErrors(error) {
  const { graphQLErrors, networkError } = error || {};
  let messageContent = '';

  if (graphQLErrors) {
    graphQLErrors.forEach(({ message }) => {
      messageContent += `[GraphQL error]: Message: ${message}`;
    });
  }

  if (networkError) {
    messageContent += `[Network error]: ${networkError}`;
  }

  return messageContent;
}

export default {
  parseError(error) {
    // Handle GraphQl errors
    let messageDisplay = parseGraphQlErrors(error);

    if (messageDisplay) {
      return messageDisplay;
    }

    const message =
      (error && typeof error === 'object' && error.message) || error;

    if (typeof message !== 'string') {
      return '';
    }

    const messageContent = message.split(':');
    messageDisplay = messageContent[1] || messageContent[0];

    return messageDisplay;
  }
};
